var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.stats.viewByYearMode)?_c('div',{staticClass:"slidecontainer"},[_c('input',{attrs:{"min":"0","max":_vm.stats.max,"id":"slider","type":"range"},on:{"input":_vm.changeSlider}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }